import Axios from "../../axios";
import { getTimezone } from "../../../helpers/date_helpers";

export function acceptInvitation(
  invitation_uuid_token: string,
  password: string
): Promise<any> {
  return Axios.post("/v1/accept_invitation", {
    invitation_uuid_token: invitation_uuid_token,
    password: password,
    timezone: getTimezone()

  }).then();
}
